import SharedRecurringTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/Recurring'

const RecurringTask = (props: Omit<Props, 'formatReward'>) => {
  return <SharedRecurringTask {...props} />
}

export default RecurringTask
